module.exports = __webpack_public_path__ + "static/media/main_image_1.751bb530.svg";